const PreSaleCommPlan518 = () => import('@/views/main/report/preSaleCommPlan518/PreSaleCommPlan518.vue')
export default {
  path: '/main/report/preSaleCommPlan518',
  name: 'preSaleCommPlan518',
  component: PreSaleCommPlan518,
  children: []
}
